import { Group, Paper, Stack, Text } from '@mantine/core';
import { primaryColor } from '../../../../constants/theme';

type BookingNoteProps =
  | {
    variant: 'no-payment';
    text?: string;
  }
  | {
    variant: 'no-response';
    text?: string;
  }
  | {
    variant: 'comment' | 'cancellation';
    text: string;
  }
  | {
    variant: 'paid';
    text: string;
  };

const NO_PAYMENT_TEXT = 'Booking did not take place due to no payment';
const NO_RESPONSE_TEXT = 'Professional did not respond to this booking';

const config = {
  comment: {
    label: 'Booking comment',
    color: primaryColor,
    textColor: 'dimmed' as const,
  },
  cancellation: {
    label: 'Cancellation reason',
    color: 'var(--mantine-color-red-6)',
    textColor: 'red' as const,
  },
  'no-payment': {
    label: 'No payment',
    color: 'var(--mantine-color-red-6)',
    textColor: 'red' as const,
  },
  'no-response': {
    label: 'No response',
    color: 'var(--mantine-color-red-6)',
    textColor: 'red' as const,
  },
  'paid': {
    label: 'Paid',
    color: primaryColor,
    textColor: 'dimmed' as const,
  }
};

export const BookingNote: React.FC<BookingNoteProps> = ({ variant, text }) => {
  const { label, color, textColor } = config[variant];
  const resolvedText =
    variant === 'no-payment'
      ? NO_PAYMENT_TEXT
      : variant === 'no-response'
        ? NO_RESPONSE_TEXT
        : text;

  return (
    <Paper
      data-testid={`booking-note-${variant}`}
      withBorder
      p="sm"
      radius="sm"
      style={{
        borderLeft: `3px solid ${color}`,
        borderTop: 'none',
        borderRight: 'none',
        borderBottom: 'none',
      }}
    >
      <Group gap={8} wrap="nowrap" align="flex-start">
        <Stack gap={2} align="flex-start">
          <Text
            data-testid={`booking-note-${variant}-label`}
            size="xs"
            c={textColor}
            fw={600}
            tt="uppercase"
            ta="left"
            style={{ letterSpacing: '0.04em' }}
          >
            {label}
          </Text>
          <Text
            data-testid={`booking-note-${variant}-text`}
            size="sm"
            ta="left"
          >
            {resolvedText}
          </Text>
        </Stack>
      </Group>
    </Paper>
  );
};
